"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  font-family: ", ";\n  font-size: ", "px;\n  color: ", ";\n  padding: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Message = _styledComponents["default"].span(_templateObject(), (0, _themeGet.themeGet)('fontFamily'), (0, _themeGet.themeGet)('buttonFontSize.0'), function (_ref) {
  var error = _ref.error;
  return error ? (0, _themeGet.themeGet)('colors.red500') : (0, _themeGet.themeGet)('colors.grey900');
}, (0, _themeGet.themeGet)('space.3'));

var _default = Message;
exports["default"] = _default;